webshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 200 ? title.substr(0, 200) + "..." : title;

			html += `<div class="list-row">`;
			html += me.get_image_html(item, title, me.settings);
			html += me.get_row_body_html(item, title, me.settings);
			html += `</div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);
	}

        get_image_html(item, title, settings) {
		let image = item.website_image;
		let image_html = `<div class="list-image" style="position:relative;">`;

		if (image) {
			image_html += `
				<a href="/${ item.route || '#' }" style="display:block;width:100%;height:100%;">
					<img itemprop="image" src="${ image }" alt="${ title }"
						style="width:100%;height:100%;object-fit:cover;object-position:center;">
					</img>
				</a>
			`;
		} else {
			image_html += `
				<a href="/${ item.route || '#' }" style="display:block;width:100%;height:100%;text-decoration:none;">
					<div class="no-image-list">
						${ frappe.get_abbr(title) }
					</div>
				</a>
			`;
		}
		image_html += `
			<div class="cart-indicator list-cart-indicator ${ item.in_cart ? '' : 'hidden' }"
				data-item-code="${ item.item_code }"
				data-uom="${ item.sales_uom }"
				style="position:absolute;top:2px;right:2px;background:var(--primary-color);
					color:white;border-radius:50%;width:18px;height:18px;font-size:10px;
					display:flex;align-items:center;justify-content:center;font-weight:600;">
				1
			</div>
		`;
		image_html += `</div>`;
		return image_html;
	}

        get_row_body_html(item, title, settings) {
		let body_html = `<div class="list-body">`;
		body_html += this.get_title_html(item, title, settings);
		body_html += this.get_item_details(item, settings);
		body_html += `</div>`;
		return body_html;
	}

        get_title_html(item, title, settings) {
		let title_html = `<div class="list-title-row">`;
		title_html += `
			<a class="list-item-title" href="/${ item.route || '#' }">
				${ title }
			</a>
		`;
		if (settings.enabled && !item.has_variants && (settings.allow_items_not_in_stock || item.in_stock)) {
			title_html += `<div class="list-cart-action">`;
			title_html += this.get_uom_selector_html(item);
			title_html += `<div class="product-action" data-uom="${item.sales_uom}">`;
			title_html += this.get_primary_button(item, settings);
			title_html += `</div>`;
			title_html += `</div>`;
		}
		title_html += `</div>`;
		return title_html;
	}

	get_item_details(item, settings) {
		let details = `
			<p class="product-code">${ item.item_code }${ item.sales_uom ? " / " + item.sales_uom : "" }</p>
			${ item.short_description ? `<div class="product-short-desc">${ item.short_description }</div>` : '' }
			<div class="product-price" data-item-code="${item.item_code}" data-uom="${item.sales_uom}" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

                if (item.group_strikethrough_price) {
			details += `
				<small class="striked-price">
					<s>${ item.formatted_group_strikethrough_price.replace(/ +/g, "") }</s>
				</small>
			`;
		} else if (item.formatted_mrp) {
			details += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}

		details += this.get_stock_availability(item, settings);
		details += `</div>`;

		return details;
	}

	get_uom_selector_html(item) {
		return window.webshop_uom_selector_html(
			item.item_code,
			item.sellable_uoms,
			item.sales_uom,
			item.route || ''
		);
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<br>
					<span class="product-stock out-of-stock mt-2" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<br>
					<span class="product-stock out-of-stock mt-2">${ __("Out of stock") }</span>
				`;
			} else if (item.is_stock) {
				return `
					<br>
					<span class="product-stock in-stock in-green has-stock mt-2"
						style="font-size: 14px;">${ __("In stock") }</span>
				`;
			}
		}
		return ``;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";

		return `
			<div class="like-action-list ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ item.item_code }">
				<svg class="icon sm">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</div>
		`;
	}

        get_primary_button(item, settings) {
		if (item.has_variants) {
			return `
				<a href="/${ item.route || '#' }">
					<div class="btn btn-sm btn-explore-variants mb-0">
						${ __("Explore") }
					</div>
				</a>
			`;
		}
		return window.webshop_action_html(item.item_code, item, 'list', settings);
	}
};
